import CubeSnappingIntoPlace from 'src/shared/assets/images/cube-snapping-into-place.png'

import { Button } from '../../buttons/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../dialog'

interface ExternalLinkAlertProps {
  isOpen: boolean
  setOpen: (open: boolean) => void
  externalLink: string
}

/** A popup that alerts the user that they are about to leave the app and go to an external link*/
export default function ExternalLinkAlert({ isOpen, setOpen, externalLink }: ExternalLinkAlertProps) {
  const stayHereOnClick = () => {
    setOpen(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={setOpen}>
      <DialogContent
        hideClose={true}
        className="flex w-[380px] max-w-[90vw] flex-col items-center rounded-[40px] px-[15px] py-[22px] sm:rounded-[40px] md:w-[420px] md:px-[25px] md:py-[32px]"
      >
        <DialogHeader className="flex flex-col items-center">
          <div className="mb-3 h-[67px] w-[69px] md:h-[78px] md:w-[80px]">
            <img src={CubeSnappingIntoPlace} alt="cube snapping into place" className="size-full object-contain" />
          </div>
          <DialogTitle className="mb-4 text-[26px] font-semibold leading-[120%] tracking-[-0.78px] md:text-[32px]">
            {"You're about to leave"}
          </DialogTitle>
        </DialogHeader>
        <p className="mt-3 text-center text-[14px] font-medium leading-[150%] text-muted md:text-[16px]">
          {
            "You're about to visit a website that isn't part of Conrad. We can't verify the safety or accuracy of content on external sites, so please proceed with caution."
          }
        </p>
        <p className="mt-3 text-center text-[14px] font-medium leading-[150%] text-primary md:text-[16px]">
          {'If you trust this link, go ahead and continue.'}
        </p>
        <div className="mt-7 flex w-full flex-row gap-4 md:gap-5">
          <Button
            variant={'link'}
            className="flex-[2] text-[15px] font-semibold md:text-[16px]"
            onClick={stayHereOnClick}
          >
            Stay here
          </Button>
          <a
            href={externalLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex h-[55px] flex-[4] items-center justify-center rounded-full bg-primary text-[15px] font-semibold text-white focus-visible:outline-none md:text-[16px]"
          >
            Yes, open link
          </a>
        </div>
      </DialogContent>
    </Dialog>
  )
}
